rs.module("controls/framework/ag/agDisplayAs",

    ["controls/framework/ag/agNameValueHelper"],

    function (nameValueHelper) {

        //
        // Function to handle the output of an ag js callback given a JSON-serialized set of DisplayAsAttribute's
        //
        function handleDisplayAs(params, displayAs) {

            // First see if we are running in a razor script template - if so, then "template" will contain the model value to use.
            // Then see if params.data exists.  If so we are running in the context of rendering a cell value.
            // Next see if params.value exists.  If so we are running in the context of a SELECT (if params.column exists) or a filter (if params.data does not exist)
            var current =
                (params.template != null) ? params.template :
                    (params.data != null) ? params.data[params.colDef.field] :
                        params.value;

            // The actual value we are going to make comparisons on
            var value = nameValueHelper.isNameValue(current) ? nameValueHelper.getValue(current) : current;
            var nameValueName = nameValueHelper.isNameValue(current) ? nameValueHelper.getName(current) : null;

            // If there is no "data" object, we are in a filter (this is a scenario specific to the grid)
            var isFilterOption = !params.data;

            // For bool filters the "values" come through as strings 'true' and 'false'. We need to convert those
            // to actual bools
            if (isFilterOption) {
                if (value === "true") {
                    value = true;
                }
                if (value === "false") {
                    value = false;
                }
            }

            // If the column had a valueFormatter defined, use that for display. Otherwise use the raw value, b\c if there is no 
            // formatter then valueFormatted is null.
            var display = params.valueFormatted || (nameValueHelper.isNameValue(current) ? nameValueHelper.getName(current) : value);

            // Override ag's default true\false display to be a checkbox, to match Html.DisplayFor
            if (value === true || value === false) {
                display = "<span class='icon " + (value ? "fas fa-check-square" : "fal fa-square") + "'></span>";
            }

            // For nulls as filter options, we want the default to be "(Blanks)" instead of just empty
            if (value == null && isFilterOption) {
                display = "(Blanks)";
            }

            var matches = displayAs.filter(item =>

                // Common\normal cases
                item.value == value ||

                // Handles CodeValues where the item.value is actually the codevalue name
                (nameValueName != null && item.value == nameValueName) ||

                // Handles enums where the value is the enum text (which is stored in valueAlternate)
                (item.valueAlternate && item.valueAlternate == value)
            );

            var match = matches.length > 0 ? matches[0] : null;

            if (match) {

                // First we'll have the display be either our text override, or whatever the default is if no text override
                var display = (match.text == null) ? display : match.text;

                // Then check if there is an icon to display
                if (match.icon) {

                    // Add the icon.  This tag format (i.e. <span class='icon'...>) matches what is done in FontAwesomeHtmlString in C#.  Didn't think
                    // it would be worth the effort to get that passed in to the JS initialization, so noted here (and there)
                    var icon = "<span class='icon " + match.icon + "'></span>";

                    // This is our new content, wrapped in a span
                    display = "<span>" + icon + " " + display + "</span>";
                }
            }

            return display;
        }

        // Exported public API
        var exports = {
            handleDisplayAs
        };

        return exports;
    }
);
